export default "/7ee56fc642439642e071ad6692a1a8b95a874bf4/4b0863dc65497c154a239df5aef64a65.png";